import { Global } from '@emotion/react';
import { RouterProvider } from '@tanstack/react-router';
import { QueryClientProvider } from 'react-query';
import { ErrorBoundary } from '@frontend/error-boundary';
import { ThemeProvider, AlertsProvider, Modal } from '@frontend/design-system';
import '@design-system/tokens';
import { useSetApiBaseUrl } from './hooks/use-set-api-base-url';
import { globalStyles } from './styles/global.styles';
import { queryClient, router } from './utils';

export default function Root() {
  useSetApiBaseUrl();

  return (
    <ErrorBoundary
      tier='app'
      feature='digital-forms-experience.root'
      team='fe-forms'
      fallback={({ error }) => {
        console.error('ErrorBoundary caught an error', error);
        return <div>An error occurred: {(error as Error).message}</div>;
      }}
    >
      <Global styles={globalStyles} />
      <QueryClientProvider client={queryClient}>
        <ThemeProvider includeEmotionTheme>
          {/* Patients fill long forms on phones: keep modals (eSign, PDF signing) on screen when the page is scrolled. */}
          <Modal.AppConfigProvider pinToViewport>
            <AlertsProvider>
              <RouterProvider router={router} />
            </AlertsProvider>
          </Modal.AppConfigProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
